/**
 * Substitutes `%NAME%`-style placeholders in a translated string.
 *
 * The i18n rows carry the placeholder in upper case (`Schritt %STEP% von %TOTAL%`), and every
 * translation must keep each one exactly once - see the header of `PS-6495-i18n-inserts.sql`.
 * Keys are matched literally, so a value is never re-scanned: a name that happens to contain
 * `%STEP%` stays as typed. A placeholder with no value is left in place rather than blanked, so a
 * missing substitution is visible instead of silently shortening the sentence.
 */
export function fillPlaceholders(text: string, values: Record<string, string | number>): string {
	return text.replace(/%([A-Z_]+)%/g, (match, name: string) =>
		Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match,
	);
}
